export default "__VITE_ASSET__37c75f46__"